import { io } from 'socket.io-client';
import urlBuilder from './helper/urlBuilder';

function getSocket(id) {
    return io(urlBuilder(), { path: '/chat/', query: `id=${id}` });
}

export default { getSocket };
